import axios from "axios";
import { BASE_URL, getLs } from ".";

axios.defaults.baseURL = `${BASE_URL}`;
axios.defaults.headers.common["Api-Token"] = getLs("token") || "";
axios.defaults.headers.common["X-Requested-With"] = `XMLHttpRequest`;
//axios.defaults.headers.common["Accept-Encoding"] = `gzip`;

axios.interceptors.response.use(
  (response) => response,
  (error) => {
    console.log(error);
    throw error;
  }
);

const Api = axios.create();
export default Api;
